import gql from 'graphql-tag';

export const CREATE_STAY_INFORMATION_LOCALIZATION_MUTATION = gql`
  mutation CreateStayInformationLocalization($data: updateStayInformationInput!) {
    createStayInformationLocalization(input: $data) {
      id
      locale
      bannerImage {
        url
      }
      title
      locale
      content
      size
    }
  }
`;
